import { submit } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators, Dispatch } from 'redux';

import { RootState } from '@store/reducers';
import { login } from '@store/auth/auth.actions';
import { getLoader } from '@store/ui/ui.selector';
import { LoadersNames } from '@store/ui/ui.actions';

import { LoginFormProps } from './index';
import LoginForm from './LoginForm';

const mapStateToProps = (state: RootState) => ({
  isLoading: getLoader(LoadersNames.loggingIn)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      loginRequest: login.started,
      submit,
    },
    dispatch,
  );

export default compose<LoginFormProps, {}>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(LoginForm);
